export const CONTRACTS = {
  EMETToken: '0x013c5C58EEe0d1B15e19504ca24AcF3E9c246A0C',
  // Active Registry (v3 - governance trio, deployed 2026-02-14)
  EMETRegistry: '0x7a03057490e8541BF4A0F879659e58Fb13f03Ca9',
  EMETStake: '0xb4A3Cf08194E445db65862Fb92bbC0cE587345bb',
  EMETTreasury: '0xe1230E68818CCE66275Ad95E1bC79517Ac1ae502',
  EMETReputation: '0x358a775b74f9369D23Ce95EDa57dcbA39A1F4d4e',
  EMETSignature: '0x6E5A8eF99D294a381bf4D0b0e27B95aFc293e074',
  // Anti-exploitation contracts (deployed 2025-07-31)
  EMETConcentration: '0xbC13370559317f363d9665a49C59538484dF27fC',
  EMETWhistleblower: '0xaa57c2cB96cceD9A56D238F2d1F9814a31CA8a26',
  // JuryPool v3 - properly wired to ChallengeV3 v3 (deployed 2026-02-14)
  EMETJuryPool: '0xcba6b6b903017Be251036CD71E231a70761009da',
  // Active ChallengeV3 (v3 - properly wired governance trio, deployed 2026-02-14)
  EMETChallengeV3: '0x12062513c3d41e5D4f0A0f2B079712D758f11EfC',
  EMETChallenge: '0x12062513c3d41e5D4f0A0f2B079712D758f11EfC', // Alias for EMETChallengeV3
  EMETJurorStake: '0x3f672390BeDac73eaCa3136552dB1197654DE20F',
  EMETSybilResistance: '0xB195c1B3161b73B1dc2958793BBEB48D7995bEa5',
  EMETDecay: '0xf75308E8093BC63cE6AcA0a01daDD918B249ab5a',
  EMETCrossModel: '0x7d19FcfFF4eD6093b9807edd7ae1b333f4b069aD',
  EMETHumanOracle: '0x017eEA4fad7dC4fb26E260B4e91354F722F6B61E',
  // Bootstrap Reserve (deployed 2025-07-02)
  EMETBootstrap: '0xb2b908953f73006ad26a1ad212F740aB5Fe38BCa',
  // Model Vouching (deployed 2026-02-18)
  EMETModelVouching: '0x9fcf40b08c81fFa7B73D2845A63282Beb9143d6F',
} as const;

// Legacy/deprecated addresses (do NOT use for new interactions)
export const LEGACY_CONTRACTS = {
  EMETRegistry_v1: '0x69FC0F525F15DFB57e762cD2c570114433AFc6e2',
  EMETRegistry_v2: '0x266D8343463deE2920CBE97EfB72B4540E491DeC',
  EMETChallenge_v1: '0x6F42c2F75aDB5e25018Ef7822E94DA3Df37E5B5A',
  EMETChallengeV2: '0x6F42c2F75aDB5e25018Ef7822E94DA3Df37E5B5A',
  EMETChallengeV3_v1: '0xfFd54b3B1D72BE8205D961566e1AD4134FBd5332',
  EMETChallengeV3_v2: '0x697BAC4b1FCA88e12003C0ef3E03bdcbdE5d17D9',
  EMETJuryPool_v1: '0xDBa7434180e09c9b0857d5808a227E32E1c79bD8',
  EMETJuryPool_v2: '0x018377D4e725703974A0087f8Ca8066c4aE8b045',
} as const;

export const BASE_CHAIN_ID = 8453;
